import { RouterProvider } from 'react-router-dom';
import UsuarioState from './contexto/usuario/UsuarioState';
import { routes } from './rutas/routes';

function App() {
    return (
        <UsuarioState>
            <RouterProvider router={routes} />
        </UsuarioState>
    );
}

export default App;
